import { createFileRoute, Outlet } from '@tanstack/react-router';

import { AppShell } from 'shared/layouts';

import { GeneralError } from 'features/errors';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell')({
  component: AppLayout,
  errorComponent: GeneralError
});

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
